import axios from "axios";

const getToken = () => {
  let token = sessionStorage.getItem("token")
    ? sessionStorage.getItem("token")
    : localStorage.getItem("token");
  let refresh = sessionStorage.getItem("refresh")
    ? sessionStorage.getItem("refresh")
    : localStorage.getItem("refresh");
  return { token, refresh };
};

const streamingClient = axios.create({
  baseURL: `${process.env.REACT_APP_API_STREAM_URL}`,
  headers: {
    // 'Cache-Control': 'no-cache',
    "content-type": "application/json",
    authorization: `vinorsoft ${getToken().token}`,
    // "Cache-Control": "no-cache",
    // "Pragma": "no-cache",
    // "Expires": "0",
  },
});
let isRefreshing = false;
streamingClient.interceptors.request.use(async (config) => {
  if (getToken().token) {
    config.headers.authorization = `vinorsoft ${getToken().token}`;
  }
  return config;
});
streamingClient.interceptors.response.use(
  (response) => {
    if (response && response.data) {
      return response.data;
    }
    return response;
  },
  async (error) => {
    if (getToken().token && error?.response?.status === 401) {
      if (!isRefreshing) {
        isRefreshing = true;
        try {
          const res = await axios.post(
            `${process.env.REACT_APP_API_URL}authenticator/refreshToken/`,
            {
              refresh: getToken().refresh,
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );

          sessionStorage.setItem("token", res.data.access);
          localStorage.setItem("token", res.data.access);

          error.config.headers.authorization = `vinorsoft ${getToken().token}`;
          isRefreshing = false;
          return streamingClient.request(error.config);
        } catch (error) {
          isRefreshing = false;
          if (error?.response?.status === 401) {
            window.location.replace("/login");
          }
          throw error;
        }
      } else {
        // Chờ đến khi token mới được cập nhật và gửi lại yêu cầu sau đó
        await new Promise((resolve) => {
          const intervalId = setInterval(() => {
            if (!isRefreshing) {
              clearInterval(intervalId);
              resolve();
            }
          }, 100);
        });
        return streamingClient.request(error.config);
      }
    }
    throw error;
  }
);

export default streamingClient;
